import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NoteService } from '../../shared/services/note.service';

@Component({
  selector: 'app-expertise-notes',
  templateUrl: './expertise-notes.component.html',
  styleUrls: ['./expertise-notes.component.scss']
})
export class ExpertiseNotesComponent implements OnInit, OnChanges {

	@Input() expertiseId: number;

	notes: any[] = [
	];

  	constructor(private noteService: NoteService) { }

  	ngOnInit() {
  	}

  	ngOnChanges(changes: SimpleChanges) {
  		if (changes && changes.expertiseId && changes.expertiseId.currentValue ) {
  			this.noteService.get('Expertise', this.expertiseId).subscribe(notes => this.notes = notes);
  		}
  	}

  	onNoteAdded(n: any) {
  		this.notes.push(n);
  	}

    onNoteDeleted(id: number) {
      console.log('note deleted',id);
      this.notes = this.notes.filter(n => n.id !== id);
    }
}
